import React from "react"
import Cpanel from "../../../static/img/vendor/cpanel.webp"

const FeaturesCpanel = () => {
  return (
    <section className="money-back-block">
      <div className="container-xl">
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="d-flex flex-column justify-content-center">
              <h3 className="mb-4 component-title text-dark-blue">
                Simplify Server & Site Management
              </h3>
              <div className="description py-4">
                cPanel & WHM is a Linux-based web hosting management solution
                that provides a robust set of automation tools in a
                straightforward interface, allowing a simplified process for
                hosting websites. cPanel supports SMBs, system administrators,
                website design agencies, hosting providers, and resellers.
              </div>
            </div>
          </div>
          <div className="col-12 col-lg-6">
            <div className="d-flex justify-content-center d-none d-lg-block  p-5">
              <img
                className="img-fluid"
                alt="Plesk Control Panel"
                src={Cpanel}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default FeaturesCpanel
